//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getMsg } from '../../assets/js/context';
import { EventSourcePolyfill } from "event-source-polyfill"
import { packageChatSpecific, chatV4Params } from '@/api/create'
import { insertData, queryByKey, queryBy, updateData, deleteData, deleteBy } from "../../assets/js/sql";
import { getInfo } from "@/api/my";
import { Toast } from 'vant'
import html2canvas from 'html2canvas'
import QRCode from 'qrcode'
const crypto = require("crypto");
export default {
  name: 'chat',
  data () {
    return {
      type: '',
      title: '',
      userInfo: {},
      top: 0,
      bottom: 0,
      voice: false,
      contentH: 0,
      shareFriendModal: false,
      qrcodeImg: '',
      html2Img: '',
      shareImgW: 0,
      shareImgH: 0,
      shareImgUrl: '',
      questionList: [],
      msg: '',
      currentObj: {},
      conversationId: '',
      isFristChat: true,
      isZj: false, //是否专家
      needScroll: true,
      conversation: {},
      queueAnswer: '',
      writeDone: true,
      stillThink: false,
      stillAnswer: false,
      allAnswer: '',
      fromPage: '',
      currentAnswerIndex: '',
      paramsId: '',
      question: '',
      keyword: '',
      keyboardH: 0,
      sse: '',
      readyToBack: false,
      class: '',
      isNewFirst: false,
      isSpecificFirst: false,
      isCreateFirst: false
    }
  },
  created () {
    this.fromPage = this.$route.query.from
    this.type = this.$route.query.type
    this.title = this.type === 'new' ? '自建会话' : this.type
    if (this.$route.query.id) {
      this.conversationId = parseInt(this.$route.query.id)
    }
    if (this.$route.query.class) {
      this.class = this.$route.query.class
    } 
    if (this.fromPage === 'createDetail') {
    this.paramsId = this.$route.query.paramsId
    this.question = this.$route.query.question
    this.keyword = this.$route.query.keyword
    this.questionList = []
    this.questionList.push({
      question: this.keyword,
      answer: "",
      child: [
        {
          type: '',
          answer: ''
        }
      ]
    });
    this.currentAnswerIndex = 0
      this.currentChildIndex = 0
      this.stillThink = true
      this.isCreateFirst = true
      this.sseAnswer(0, this.paramsId, true)
    } else {
      this.beforeGetList()
    }
    if (this.$global.isApp) {
      this.top = api.safeArea.top
      this.bottom = api.safeArea.bottom
    }
    this.$bus.$off('systemChatback')
    this.$bus.on("systemChatback", (value) => {
      // console.log('系统返回')
      this.onClickLeft()
    });
  },
  mounted () {
    this.contentH = this.top + 46 + 60 + this.bottom
  },
  activated () {
    this.readyToBack = false
    this.getUser()
  },
  methods: {
    showStopBtn (index, aIndex) {
      if (this.currentAnswerIndex === index && this.currentChildIndex === aIndex && this.stillAnswer) {
        return true
      } else {
        return false
      }
    },
    showCopyBtn(index, aIndex) {
      if (this.currentAnswerIndex !== index) {
        return true
      } else {
        if (this.currentChildIndex !== aIndex) {
          return true
        } else {
          if (this.stillAnswer) {
            return false
          } else {
            return true
          }
        }
      }
    },
    stopTalk (index, aIndex, child) {
      this.currentStopTalk = true
      this.stillThink = false
      this.stillAnswer = false
      this.allAnswer = child.answer
      let item = this.questionList[index]
      item.child[aIndex] = child
      this.$set(this.questionList[index], "answer", child.answer);
      this.$set(this.questionList[index], "child", item.child);
      if (aIndex > 0) { // 重新回答
        let time = Date.now()
        let obj = {
          conversationDetailId: item.id,
          type: child.type,
          status: 'normal',
          question: child.question,
          answer: child.answer,
          createTime: time,
          updateTime: time
        }
        if (this.currentSavedChatID) {
          obj.id = this.currentSavedChatID
          this.updateChatData(obj)
        } else {
          this.saveChatData(obj)
        }
      } else {
        this.doUpdateDB(index)
      }
    },
    onClickLeft () {
      this.$router.goBack(-2)
    },
    beforeGetList () {
      if (localStorage.getItem('specific')) {
        this.getList()
      } else {
        packageChatSpecific().then(res => {
          let expertList = res.data
          localStorage.setItem('specific', JSON.stringify(expertList))
          this.getList()
        })
      }
    },
    async getList () {
      this.questionList = []
      let type = this.type
      if (type === 'new') {
        console.log('新会话')
        if (!this.conversationId) {
          this.isNewFirst = true
        } else {
          let conversationId = this.conversationId
          let conversation = await queryByKey('conversation', conversationId)
          console.log(conversation)
          if (conversation) {
            this.conversation = conversation
          }
          this.getQuestionList(conversationId)
        }
      } else {
        console.log('创作和专家', this.class)
        // 创作和专家
        if (this.class === 'specific') {
          let currentArr = JSON.parse(localStorage.getItem('specific-detail'))
          console.log(currentArr)
          this.isZj = true
          let conversation = await queryBy('conversation', 'type', type)
          if (!conversation.data.length) {
            this.currentObj = currentArr
            this.isSpecificFirst = true // 标记是第一次进专家
            setTimeout(() => {
              this.$nextTick(() => {
                this.scrollToBottom()
              });
            }, 400)
          } else {
            this.conversation = conversation.data[0]
            this.getQuestionList(this.conversation.id)
          }
        } else {
          this.isZj = false
          let conversationId = this.conversationId
          let conversation = await queryByKey('conversation', conversationId)
          console.log(conversation)
          if (conversation) {
            this.conversation = conversation
          }
          this.getQuestionList(conversationId)
        }
      }
    },
    async getQuestionList (conversationId) {
      console.log('查询数据开始：', Date.now())
      let res = await queryBy('conversation_detail', 'conversationId', conversationId * 1)
      this.questionList = []
      res.data.forEach(async (item, index) => {
        let child = await queryBy('chat', 'conversationDetailId', item.id * 1)
        item.child = child.data
        this.questionList.push(item)
        if (index === res.data.length - 1) {
          setTimeout(() => {
            this.$nextTick(() => {
              this.scrollToBottom()
            });
          }, 400)
        }
      });
      console.log('查询数据结束：', this.questionList, Date.now())
    },
    scrollToBottom () {
      if (!this.needScroll) {
        return
      }
      var div = document.getElementById("chat-warp");
      if (!div) return
      div.scrollTop = div.scrollHeight;
      document.documentElement.scrollTop = div.scrollHeight;
      this.needScroll = true
    },
    retryChat (item, index) {
      this.needScroll = true
      this.stillThink = true
      let list = this.questionList.filter((item, i) => i < index)
      this.currentAnswerIndex = index
      this.currentChildIndex = item.child.length
      let messages = getMsg(list, item.question)
      console.log('上下文：', messages)
      let currentItem = JSON.parse(JSON.stringify(item))
      // 追加一条空chat数据 用于显示正在思考中...
      item.child.push({
        type: this.type,
        answer: ''
      });
      this.initCurrentSaved()
      this.$set(this.questionList[index], "child", item.child);
      setTimeout(() => {
        this.scrollToBottom()
      }, 100);
      let param = {
        "messages": messages,
        "type": this.title
      }
      if (this.type === "new") { //新建会话
        param = {
          "messages": messages,
        }
      }
      chatV4Params(param).then((res) => {
        // console.log(res);
        if (res.code === 405) {
          this.stillThink = false
          this.stillAnswer = false
          let child = currentItem.child
          child.push({
            type: this.type,
            status: 'subscribe',
            answer: res.message
          })
          this.$set(this.questionList[index], "child", child);
  
            // this.$router.push({
            //   path: "/subscribe?type=nobalance",
            //   query: {
            //     from: 'home'
            //   }
            // });
          return;
        }
        if (res.code === 200) {
          this.sseAnswer(index, res.data.paramsId, false, currentItem)
        }
      }).catch((v) => {
        // console.log("err", v);
        this.stillThink = false
        this.stillAnswer = false
        if (v.code === 401 && !localStorage.getItem("wxToken")) {
          console.log("游客过期");
          if (this.questionList.length) {
            let child = currentItem.child
            child.push({
              conversationDetailId: item.id,
              type:  this.type,
              status: 'device401',
              answer: '小洽刚刚开小差了，请您再问一次'
            })
            this.$set(this.questionList[index], "child", child);
          }
        } else {
          if (this.questionList.length) {
            let answer = v.message || "网络异常!"
            let childIndex = item.child.length
            item.child[childIndex - 1] = {
              type: this.type,
              status: v.code || '1000',
              answer: answer
            }
            this.$set(this.questionList[index], "child", item.child);
          }
        }
      });
    },
    doSaveDB (index) {
      if (this.type === 'new') {
        let time = Date.now()
        if (this.isNewFirst) {
          let obj = {
            type: this.type,
            title: this.title,
            class: 'new',
            keyword: this.questionList[index].question,
            question: this.questionList[index].question,
            answer: this.questionList[index].answer,
            createTime: time,
            updateTime: time
          }
          this.saveConversationData(obj)
        } else {
          // 更新conversation
          this.conversation.updateTime = time
          this.conversation.class = 'new'
          console.log('new更新会话')
          this.updateConversationData(this.conversation)
          //插入新的会话数据
          let obj = {
            conversationId: this.conversationId,
            type: this.type,
            question: this.questionList[index].question,
            answer: this.questionList[index].answer,
            createTime: time,
            updateTime: time
          }
          console.log('new追加会话详细')
          this.saveConversationDetailData(obj)
        }
      } else {
        if (this.isZj) { // 专家
          let time = Date.now()
          if (this.isSpecificFirst) { //没有当前专家会话 新建会话 conversation
            let obj = {
              type: this.type,
              title: this.type,
              class: 'specific',
              keyword: this.currentObj.question,
              question: this.currentObj.question,
              answer: this.currentObj.answer,
              createTime: time,
              updateTime: time
            }
            console.log('专家首次新建会话')
            this.saveConversationData(obj, this.questionList[index])
          } else { //有当前类型专家会话
            // 更新conversation
            this.conversation.updateTime = time
            this.conversation.class = 'specific'
            console.log('专家更新会话')
            this.updateConversationData(this.conversation)
            //插入新的会话数据
            let obj = {
              conversationId: this.conversationId,
              type: this.type,
              question: this.questionList[index].question,
              answer: this.questionList[index].answer,
              createTime: time,
              updateTime: time
            }
            console.log('专家追加会话详细')
            this.saveConversationDetailData(obj)
          }
        } else { // 创作
          let time = Date.now()
          this.conversation.updateTime = time
          this.conversation.class = 'create'
          console.log('创作更新会话')
          this.updateConversationData(this.conversation)
          let obj = {
            conversationId: this.conversationId,
            type: this.type,
            question: this.questionList[index].question,
            answer: this.questionList[index].answer,
            createTime: time,
            updateTime: time
          }
          console.log('创作追加会话详细')
          this.saveConversationDetailData(obj)
        }
      }
    },
    newSaveDB (index) {
      let time = Date.now()
      let obj = {
        type: this.type,
        title: this.type,
        class: 'create',
        keyword: this.keyword,
        question: this.question,
        answer: this.questionList[index].answer,
        createTime: time,
        updateTime: time
      }
      console.log('创作新建会话')
      this.saveConversationData(obj)
    },
    doUpdateDB (index) {
      let time = Date.now()
      if (this.type === 'new') {
        if (this.isNewFirst) {
          let obj = {
            type: this.type,
            title: this.title,
            class: 'new',
            keyword: this.questionList[index].question,
            question: this.questionList[index].question,
            answer: this.questionList[index].answer,
            createTime: time,
            updateTime: time
          }
          if (!this.currentSavedConversationID) {
            console.log('停止 未保存会话，new新建会话')
            this.saveConversationData(obj)
          } else {
            console.log('停止 已保存会话，new删除会话')
            this.removeConversationData(this.currentSavedConversationID)
            console.log('停止 已保存会话，new重新建会话')
            this.saveConversationData(obj)
          }
        } else {
          if (this.currentSavedConversationDetailID) {
          // 更新数据库
            console.log('停止 已有会话，new更新会话详细')
            this.updateConversationDetailData(this.conversationId)
          } else {
            //存储
            let obj = {
              // conversation_detail数据
              conversationId: this.conversationId,
              type: this.type,
              question: this.questionList[index].question,
              answer: this.questionList[index].answer,
              createTime: time,
              updateTime: time
            }
            console.log('停止 已有会话，new新增会话详细')
            this.saveConversationDetailData(obj)
          }
        }
      } else {
        if (this.isZj) {
          if (this.isSpecificFirst) { //没有当前专家会话 新建会话 conversation
            let obj = {
              type: this.type,
              title: this.type,
              class: 'specific',
              keyword: this.currentObj.question,
              question: this.currentObj.question,
              answer: this.currentObj.answer,
              createTime: time,
              updateTime: time
            }
            if (!this.currentSavedConversationID) {
              console.log('停止 未保存会话，专家新建会话')
              this.saveConversationData(obj, this.questionList[index])
            } else {
              console.log('停止 已保存会话，专家删除会话')
              this.removeConversationData(this.currentSavedConversationID)
              console.log('停止 已保存会话，专家重新建会话')
              this.saveConversationData(obj, this.questionList[index])
            }
          } else { //已经有专家了
            if (this.currentSavedConversationDetailID) {
            // 更新数据库
              console.log('停止 已有会话，专家更新会话详细')
              this.updateConversationDetailData(this.conversationId)
            } else {
              //存储
              // conversation_detail数据
              let obj = {
                conversationId: this.conversationId,
                type: this.type,
                question: this.questionList[index].question,
                answer: this.questionList[index].answer,
                createTime: time,
                updateTime: time
              }
              console.log('停止 已有会话，专家新增会话详细')
              this.saveConversationDetailData()
            }
          }
        } else {
          if (this.isCreateFirst) {
             if (!this.currentSavedConversationID) {
              console.log('停止 未保存会话，创作新建会话')
              this.newSaveDB(index)
             } else {
              console.log('停止 已保存会话，创作删除会话')
              this.removeConversationData(this.currentSavedConversationID)
              console.log('停止 已保存会话，创作重新建会话')
              this.newSaveDB(index)
            }
          } else {
            if (this.currentSavedConversationDetailID) {
            // 更新数据库
              console.log('停止 已有会话，创作更新会话详细')
              this.updateConversationDetailData(this.conversationId)
            } else {
              //存储
              let obj = {
                // conversation_detail数据
                conversationId: this.conversationId,
                type: this.type,
                question: this.questionList[index].question,
                answer: this.questionList[index].answer,
                createTime: time,
                updateTime: time
              }
              console.log('停止 已有会话，创作新增会话详细')
              this.saveConversationDetailData(obj)
            }
          }
        }
      }
    },
     async queryConversationDetailData(conversationId) {
      let res = await queryBy('conversation_detail', 'conversationId', conversationId * 1)
      let conversationDetailIds = []
      res.data.forEach(async (item, index) => {
        conversationDetailIds.push(item.id)
        if (index === res.data.length - 1) {
          this.removeChatData(conversationDetailIds)
          this.removeConversationDetailData(conversationId)
        }
      });
    },
    removeConversationDetailData (conversationId) {
      deleteBy("conversation_detail", 'conversationId', conversationId)
    },
    removeChatData(conversationDetailIds) {
      conversationDetailIds.forEach(item => {
        deleteBy("chat", 'conversationDetailId', item)
      })
    },
    removeConversationData (id) {
      deleteData("conversation", id * 1).then(res=> {
        console.log('删除会话')
      })
      this.queryConversationDetailData(id)
    },
    updateConversationData (obj) {
      updateData("conversation", obj).then(res => {
        console.log('更新conversation', res.target.result)
      })
    },
    saveConversationData (obj, item) {
      insertData("conversation", obj).then(res => {
        this.conversationId = res.target.result
        this.conversation = obj
        this.conversation.id = this.conversationId
        this.currentSavedConversationID = res.target.result
        // conversation_detail数据
        let obj1 = {
          conversationId: res.target.result,
          type: obj.type,
          keyword: obj.keyword,
          question: obj.question,
          answer: obj.answer,
          createTime: obj.createTime,
          updateTime: obj.updateTime
        }
        this.saveConversationDetailData(obj1)
        if (item) {
          // conversation_detail数据
          let obj2 = {
            conversationId: res.target.result,
            type: this.type,
            question: item.question,
            answer: item.answer,
            createTime: obj.createTime,
            updateTime: obj.createTime
          }
          this.saveConversationDetailData(obj2)
        }
      })
    },
    updateConversationDetailData (conversationId) {
      let time = Date.now()
      // conversation_detail数据
      let obj = {
        id: this.currentSavedConversationDetailID,
        conversationId: conversationId,
        type: this.type,
        question: this.questionList[this.currentAnswerIndex].question,
        answer: this.questionList[this.currentAnswerIndex].answer,
        createTime: time,
        updateTime: time
      }
      updateData("conversation_detail", obj).then(res => {
        // chat数据
        let obj1 = {
          conversationDetailId: res.target.result,
          type: obj.type,
          status: 'normal',
          question: obj.question,
          answer: obj.answer,
          createTime: obj.createTime,
          updateTime: obj.updateTime
        }
        if (this.currentSavedChatID) {
          // 更新chat
          obj1.id = this.currentSavedChatID
          this.updateChatData(obj1)
        } else {
          // 存储chat
          this.saveChatData(obj1)
        }
      })
    },
    saveConversationDetailData (obj) {
      insertData('conversation_detail', obj).then((res) => {
        this.currentSavedConversationDetailID = res.target.result
        // chat数据
        let obj1 = {
          conversationDetailId: res.target.result,
          type: obj.type,
          status: 'normal',
          question: obj.question,
          answer: obj.answer,
          createTime: obj.createTime,
          updateTime: obj.updateTime
        }
        this.saveChatData(obj1)
      });
    },
    updateChatData (obj) {
       updateData("chat", obj).then(res => {
       })
    },
    saveChatData (obj) {
      insertData('chat', obj).then((res) => {
        this.currentSavedChatID = res.target.result
      });
    },
    copy (value) {
      if (this.$global.isAp) {
        var clipBoard = api.require('clipBoard')
        clipBoard.set(
          {
            value: value,
          },
          function (ret, err) {
            // console.log('复制', ret, err)
            if (ret.status) {
              Toast({
                message: '复制成功',
                duration: 1000,
              })
            } else {
              Toast({
                message: '复制失败',
                duration: 1000,
              })
            }
          }
        )
      } else {
        var input = document.createElement('input');
        input.setAttribute('id', 'copyInput');
        input.setAttribute('value', value);
        document.body.appendChild(input);
        document.getElementById('copyInput').select();
        document.execCommand('copy')
        Toast.success("复制成功")
        document.body.removeChild(input)
      }
    },
    goBottom () {
      var div = document.getElementById('chat-warp')
      div.scrollTop = div.scrollHeight
      document.documentElement.scrollTop = div.scrollHeight
      // console.log(div.scrollHeight, div.scrollTop)
    },
    sendMsg () {
      // console.log(this.msg)
      if (this.isNull(this.msg)) {
        Toast({
          message: '信息不能为空',
          duration: 2000,
        })
        return
      }
      this.answer(this.msg.replace(/(^s*)|(s*$)/g, ""))
    },
    isNull (str) {
      if (str == "") return true;
      var regu = "^[ ]+$";
      var re = new RegExp(regu);
      return re.test(str);
    },
    sign (timestampStr, uuid) {
      // console.log('签名：', timestampStr, uuid)
      let secret = "l8c2scudgvf3aavrkuohep4r6a16nj7s"
      let stringToSign = timestampStr + uuid;
      let mac = crypto.createHmac("sha256", secret);
      mac.update(stringToSign);
      let signData = mac.digest();
      let signStr = Buffer.from(signData).toString("base64");
      let stringToSignStr = Buffer.from(stringToSign).toString("base64");
      return signStr + stringToSignStr;
    },
    async sseAnswer(index, paramsId, isNew, retryChatItem) {
      this.currentStopTalk = false
      let sse;
      let uid = window.localStorage.getItem("uid");
      if (uid == null || uid == '' || uid == 'null') {
        uid = this.uuid();
      }
      // 设置本地存储
      // window.localStorage.setItem("uid", uid);
      let _this = this;
      let headers = {}
      if (global.isApp) {
        // 1，把timestamp+uuid当做签名字符串，使用HmacSHA256算法计算签名，然后进行Base64 encode。
        // 2,把timestamp+uuid和第一步得到的签名值拼接到前面去
        // 3,把结果放到请求头里，Authorization : Bearer2 rBrGIfY1nL0u7KFpQ+VOXSj6q+ye3b/3SPxK03YtaNA=MTY3ODA4NTUxNDY0MEZDNDA4RjhCLTk1OTgtNDhCNi1BNzQwLUI5MDM3QURDWFhYRQ==
        let deviceId = localStorage.getItem('deviceId')
        let Bearer = "";
        if (api.systemType === "ios") {
          Bearer = "Bearer1 ";
          headers['gptsystem'] = 'ios'
        } else {
          headers['gptsystem'] = 'android'
          // 安卓目前取不到唯一的deviceId
          if (!deviceId) {
            deviceId = api.deviceId;
            localStorage.setItem("deviceId", deviceId);
          }
          Bearer = "Bearer2 ";
        }
        let wxToken = localStorage.getItem("wxToken");
        let appleToken = localStorage.getItem("appleToken");
        let token = localStorage.getItem("token");
        if (deviceId) {
          const timestamp = new Date().getTime();
          let signStr = this.sign(timestamp.toString(), deviceId);
          headers["Authorization"] = Bearer + signStr;
        }
        // let channelCode = localStorage.getItem('channelCode')
        // if (channelCode && channelCode !== 'none' && channelCode !== '') {
        //   headers['Terminal'] = channelCode
        // }
        if (wxToken) {
          headers["Token"] = Bearer + wxToken;
        } else if (appleToken) {
          headers["Token"] = Bearer + appleToken;
        } else if (token) {
          headers["Token"] = Bearer + token;
        }
      } else {
        let uuid = localStorage.getItem('uuid')
        let token = localStorage.getItem('token')
        // if (!uuid) {
        //   uuid = getUuid()
        // }
        const timestamp = new Date().getTime()
        let signStr = this.sign(timestamp.toString(), uuid)
        headers['Authorization'] = 'Bearer3 ' + signStr
        if (token) {
          headers['Token'] = 'Bearer3 ' + token
        }
      }
      headers['uid'] = this.uuid()
      const eventSource = new EventSourcePolyfill(process.env.API_HOST + '/chat/v4?paramsId=' + paramsId, {
          headers: headers
      });
      eventSource.onopen = (event) => {
        console.log("onopen", event, event.readyState, event.target);
        sse = event.target;
        _this.sse = sse
      };
      let child = []
      if (retryChatItem) { // 如果是重新回答，取出当前问答的所有答案
        child = retryChatItem.child
        child.push({
          conversationDetailId: retryChatItem.id,
          type: this.type,
          status: 'normal',
          answer: ''
        })
      } else {
        child.push({
          type: this.type,
          status: 'normal',
          answer: ''
        })
      }
      let answer = ''
      eventSource.onmessage = async (event) => {
        if (this.currentStopTalk) {
          if (sse) {
            sse.close();
          }
          return;
        }
        if (this.readyToBack) {
          if (sse) {
            sse.close();
          }
          return;
        }
        if (event.data == "[DONE]") {
          console.log('结束')
          this.allAnswer = answer
          this.questionList[index].answer = answer
          if (retryChatItem) {
            let time = Date.now()
            let obj1 = {
              conversationDetailId: retryChatItem.id,
              type: retryChatItem.type,
              status: 'normal',
              question: retryChatItem.question,
              answer: this.questionList[index].answer,
              createTime: time,
              updateTime: time
            }
            this.saveChatData(obj1)
          // this.retryScroll(index)
          } else {
            if (isNew) {
              this.newSaveDB(index)
            } else {
              this.doSaveDB(index)
            }
          }
          if (sse) {
            sse.close();
          }
          return;
        }
        let json_data = JSON.parse(event.data)
        if (json_data.content == null || json_data.content == 'null') {
          return;
        }
        answer += json_data.content
        this.queueAnswer += json_data.content
        this.queue(index, child)
        this.$nextTick(() => {
          this.scrollToBottom()
        }, 100);
      };
      eventSource.onerror = (event) => {
        console.log("onerror 服务异常请重试并联系开发者！", event);
        this.stillAnswer = false
        this.stillThink = false
        if (this.questionList.length) {
          let child = []
          let answer = "网络异常!"
          child.push({
            type: this.type,
            status: '1000',
            answer: answer
          })
          this.$set(this.questionList[index], "answer", answer);
          this.$set(this.questionList[index], "child", child);
        }
        if (event.readyState === EventSource.CLOSED) {
          console.log('connection is closed');
        } else {
          console.log("Error occured", event);
        }
        event.target.close();
      };
      eventSource.addEventListener("customEventName", (event) => {
        console.log("Message id is " + event.lastEventId);
      });
    },
    async queue (index, child) {
      setTimeout(async ()=> {
        if (this.readyToBack) {
          return
        }
        if (this.writeDone) {
          let msg = this.queueAnswer
          this.queueAnswer = ''
          console.log(msg)
          if (!msg) {
            return
          }
          if (this.currentStopTalk) {
            return
          }
          this.writeDone = false
          this.stillThink = false
          this.stillAnswer = true
          let res = await this.typeMessage(index, child, msg, 50, false);
          this.writeDone = res
        } else {
          if (!this.queueAnswer) {
            return
          }
          this.queue(index, child)
        }
      }, 500)
    },
    // 调用 typeMessage 函数来逐字输出消息
    // typeMessage("Hello, world! This is a test message.", 50);
    async typeMessage (index, child, message, delay, doSave) {
       return new Promise((resolve,reject) => {
          let i = 0;
          const intervalId = setInterval(() => {
            if (this.currentStopTalk) {
             clearInterval(intervalId);
             resolve(true)
            }
            if (this.readyToBack) {
              clearInterval(intervalId);
              resolve(true)
            }
            let msg = message.charAt(i)

            child[child.length - 1].answer += msg
            this.$set(this.questionList[index], "answer", child[child.length - 1].answer);
            this.$set(this.questionList[index], "child", child);

            // this.questionList[index].child = child;
            this.$nextTick(() => {
              this.scrollToBottom()
            }, 100);
            // outputDiv.innerHTML += message.charAt(i);
            i++;
            if (i > message.length) {
              if (this.allAnswer === child[child.length - 1].answer) {
                console.log('输出完成')
                if (this.conversationId) { // 第一次已经输出完成并保存 标记为非第一次
                  this.isSpecificFirst = false
                  this.isCreateFirst = false
                  this.isNewFirst = false
                }
                this.stillAnswer = false
              }
              if (doSave) {
                let time = Date.now()
                let obj = {
                  type: 'homeChat',
                  question: this.questionList[index].question,
                  answer: this.questionList[index].answer,
                  createTime: time,
                  updateTime: time
                }
                this.saveConversationData(obj)
              }
              clearInterval(intervalId);
              resolve(true)
            }
          }, delay);
      });
    },
    uuid () {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";

      var uuid = s.join("");
      return uuid;
    },
    initCurrentSaved () {
      this.currentSavedConversationDetailID = ''
      this.currentSavedChatID = ''
    },
    answer (question) {
      if (this.stillThink) {
        Toast('小洽正在思考您的问题，请稍候')
        return
      }
      if (this.stillAnswer) {
        Toast('小洽正在回答您的问题，请稍候')
        return
      }
      this.stillThink = true
      this.msg = "";
      // this.resetContentH()
      let index = this.questionList.length;
      this.currentAnswerIndex = index
      this.currentChildIndex = 0
      let messages = getMsg(this.questionList, question)
      this.questionList.push({
        question: question,
        answer: "",
        child: [
          {
            type: '',
            answer: ''
          }
        ]
      });
      this.initCurrentSaved()
      this.$nextTick(() => {
        this.scrollToBottom()
      })
      let param = {
        "messages": messages,
        "type": this.title
      }
      if (this.type === "new") { //新建会话
        param = {
          "messages": messages,
        }
      }
      chatV4Params(param).then(res => {
        console.log(res)
        if (res.code === 405) {
          this.stillAnswer = false
          this.stillThink = false
          let child = []
          child.push({
            type: this.type,
            status: 'subscribe',
            answer: res.message
          })
          this.$set(this.questionList[index], "answer", res.message);
          this.$set(this.questionList[index], "child", child);
          //  setTimeout(() => {
            // this.$router.push({
            //   path: "/subscribe?type=nobalance",
            //   query: {
            //     from: 'chat'
            //   }
            // });
          // }, 1000);
          return
        }
        if (res.code === 200) {
          console.log('chatV4:', res.data.paramsId)
          this.sseAnswer(index, res.data.paramsId)
        }
        setTimeout(() => {
          var div = document.getElementById('chat-warp')
          div.scrollTop = div.scrollHeight
          document.documentElement.scrollTop = div.scrollHeight
        }, 10);
      }).catch(v => {
         this.stillAnswer = false
         this.stillThink = false
          console.log("err", v);
          if (v.code === 401 && !localStorage.getItem("wxToken")) {
            console.log("游客过期");
            if (this.questionList.length) {
              let child = []
              child.push({
                type: 'homeChat',
                status: 'device401',
                answer: '小洽刚刚开小差了，请您再问一次'
              })
              this.$set(this.questionList[index], "answer", "小洽刚刚开小差了，请您再问一次");
              this.$set(this.questionList[index], "child", child);
            }
          } else {
            if (this.questionList.length) {
              let child = []
              let answer = v.message || "网络异常!"
              child.push({
                type: 'homeChat',
                status: v.code || '1000',
                answer: answer
              })
              this.$set(this.questionList[index], "answer", answer);
              this.$set(this.questionList[index], "child", child);
            }
          }
        setTimeout(() => {
          var div = document.getElementById("chat-warp");
          div.scrollTop = div.scrollHeight;
          document.documentElement.scrollTop = div.scrollHeight;
        }, 100);
      })
    },
    getDPR () {
      if (window.devicePixelRatio && window.devicePixelRatio > 1) {
        return window.devicePixelRatio;
      }
      return 1;
    },
    /**
     * 将传入值转为整数
     * @param value
     * @returns {number}
     */
    parseValue: function (value) {
      return parseInt(value, 10);
    },
    drawAndShareImage () {
      // 获取像素比
      var scaleBy = this.getDPR();
      let width = this.shareImgW * scaleBy
      let height = this.shareImgH * scaleBy
      let pageH = window.screen.height * scaleBy // height + footerImgH
      let footerImgW = width
      let footerImgH = footerImgW * 558 / 1080
      let footerImgX = 0
      let footerImgY = pageH - footerImgH

      let imgTop = 15 * scaleBy
      let imgY = imgTop + 5 * scaleBy
      let imgH = pageH - footerImgH - (imgTop * 2)
      let imgW = imgH * width / height
      let imgX = (width - imgW) / 2

      var canvas = document.createElement('canvas')
      canvas.width = width;
      canvas.height = pageH;
      var context = canvas.getContext('2d')
      context.rect(0, 0, canvas.width, canvas.height)
      context.fillStyle = 'transparent'
      context.fill()
      var shareBkImg = new Image()
      shareBkImg.src = '../../../static/home/sharebk.png'
      shareBkImg.crossOrigin = 'Anonymous'
      let _this = this
      shareBkImg.onload = function () {
        context.drawImage(shareBkImg, 0, 0, width, pageH)
        // var bkImg = new Image()
        // bkImg.src = './../../../../../static/subscribe/Fg.png' //你自己本地的图片或者在线图片
        // bkImg.crossOrigin = 'Anonymous'
        // bkImg.onload = function() {
        //   context.drawImage(bkImg, imgX, imgY, imgW, imgH)
        //   console.log('bkImg:', bkImg.width, bkImg.height)
        var domImage = new Image()
        domImage.src = _this.html2Img //背景图片 你自己本地的图片或者在线图片
        domImage.crossOrigin = 'Anonymous'
        domImage.onload = function () {
          context.drawImage(domImage, imgX, imgY, imgW, imgH)
          var footerImg = new Image()
          footerImg.src = '../../../static/home/sharefooter.png' //你自己本地的图片或者在线图片
          footerImg.crossOrigin = 'Anonymous'
          footerImg.onload = function () {
            context.drawImage(footerImg, footerImgX, footerImgY, footerImgW, footerImgH)
            var qrcodeDom = document.getElementById('qrcode')
            // console.log(qrcodeDom)
            let url = process.env.BASE_URL + '/home' + '?inviteCode=' + _this.userInfo.inviteCode
            QRCode.toCanvas(qrcodeDom, url, {
              errorCorrectionLevel: 'H',
              type: 'image/png',
              quality: 0.3,
              margin: 1
            }, function (error, dom) {
              if (error) console.error(error)
              // console.log('success!', dom.toDataURL('image/png'));
              _this.qrcodeImg = dom.toDataURL('image/png')
              _this.$nextTick(() => {
                let qrImg = new Image()
                qrImg.src = _this.qrcodeImg
                qrImg.onload = () => {
                  context.drawImage(qrImg, width - 15 * scaleBy - (footerImgH / 2), pageH - (footerImgH / 2) - (footerImgH / 3), footerImgH / 2, footerImgH / 2)
                  var base64 = canvas.toDataURL('image/png') //"image/png" 这里注意一下
                  // console.log(base64)
                  _this.shareImgUrl = base64
                  Toast.clear();
                  _this.shareFriendModal = true
                }
              })
            })
          }
        }
        // } 
      }

    },
    shareUrl () {
      let _this = this
      const toast = Toast.loading({
        message: '生成中...',
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
      });
      let centerDom = document.getElementById('chat')
      let box = window.getComputedStyle(centerDom)
      // dom节点计算后宽高
      var width = _this.parseValue(box.width);
      var height = _this.parseValue(box.height);
      this.shareImgW = width
      this.shareImgH = height
      // 获取像素比
      var scaleBy = _this.getDPR();
      // console.log(scaleBy)
      // 创建自定义的canvas元素
      var canvas = document.createElement('canvas');

      // 设置canvas元素属性宽高为 DOM 节点宽高 * 像素比
      canvas.width = width * scaleBy;
      canvas.height = height * scaleBy;

      // 设置canvas css 宽高为DOM节点宽高
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';

      // 获取画笔
      var context = canvas.getContext('2d');
      context.fillStyle = 'transparent'
      context.fill()

      // 将所有绘制内容放大像素比倍
      context.scale(scaleBy, scaleBy);

      html2canvas(centerDom, {
        backgroundColor: null,
        width: width,
        height: height,
        useCORS: true,
        allowTaint: true
      }).then((canvas) => {
        // console.log(canvas)
        this.html2Img = canvas.toDataURL('image/png')
        // console.log(this.html2Img)
        this.drawAndShareImage()
      });
    },
    getUser () {
      // console.log("home: info");
      getInfo().then((res) => {
        this.userInfo = res.data;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/Mine/chat.vue